import React, { useEffect, useState } from 'react';

import { debugLog, featureManager } from '@schibsted-nmp/advertising-shared';
import { advtPerformance } from '@schibsted-nmp/advertising-events';

import { getState } from '../../../state/reducer';

const getFeatures = () => {
  const { initialState } = getState();
  return (
    initialState?.unleash.features &&
    featureManager(initialState.unleash.features)
  );
};

export const useRemoveUtifSizes = (targetId: string) => {
  // Hack to fix Relevant Digital & Xandr size bug
  useEffect(() => {
    if (
      getFeatures()?.removeUtifSizesEnabled() &&
      targetId.includes('advt_middle_')
    ) {
      const id = `div_utif_${targetId}`;
      const utifDiv = document.getElementById(id);
      if (utifDiv) {
        // remove all utifDiv styles
        utifDiv.style.height = '';
        utifDiv.style.width = '';
      }
    }
  });
};

// leaving it here until verified that it works
export const useIframeHeightForBanner = (
  targetId: string,
  ref: React.RefObject<HTMLDivElement>,
  initialHeight: number
) => {
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    // Check if MutationObserver is supported
    if (typeof MutationObserver === 'undefined') {
      console.warn('MutationObserver is not supported by your browser.');
      return () => {};
    }

    function setHeightFromIframe(iframe: HTMLIFrameElement) {
      if (iframe) {
        const iframeHeight = iframe.getAttribute('height');
        const newHeight = iframeHeight
          ? parseInt(iframeHeight, 10)
          : initialHeight;
        if (!Number.isNaN(newHeight)) {
          debugLog(
            `Setting height to ${newHeight}px. InitialHeight was ${initialHeight}px`
          );
          if (newHeight !== initialHeight) {
            advtPerformance.markXandrEvents(
              `Setting height on ad from ${initialHeight}px to ${newHeight}px`
            );
          }
          setHeight(newHeight);
        }
      }
    }

    let heightObserver: MutationObserver | null = null;
    let iframeObserver: MutationObserver | null = null;
    let iframe: HTMLIFrameElement | null = null;

    if (getFeatures()?.isIframeHeightOnBannersEnabled()) {
      heightObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'height' &&
            iframe
          ) {
            setHeightFromIframe(iframe);
          }
        });
      });

      iframeObserver = new MutationObserver(() => {
        if (ref.current) {
          const [firstIframe] =
            ref.current.getElementsByTagName('iframe') || [];
          if (firstIframe) {
            iframe = firstIframe;
            // Set default height
            setHeightFromIframe(iframe);
            // Add null check before using observer
            if (heightObserver) {
              heightObserver.observe(iframe, {
                attributes: true,
                attributeFilter: ['height']
              });
            }
          }
        }
      });

      if (ref.current) {
        iframeObserver.observe(ref.current, {
          childList: true,
          subtree: true
        });
      }
    }
    return () => {
      if (heightObserver) {
        heightObserver.disconnect();
      }
      if (iframeObserver) {
        iframeObserver.disconnect();
      }
    };
  }, [ref.current]);
  return height;
};
